import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/evaluation-templates',
        name: 'evaluation-templates-index',
        component: () => import('@/pages/evaluation-templates/EvaluationTemplateIndex.vue'),
        meta: {
            title: 'Evaluation Templates',
            dataTablePage: true,
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view all', subject: 'evaluation templates' },
        },
    },

    {
        path: '/evaluation-templates/create',
        name: 'evaluation-templates-create',
        component: () => import('@/pages/evaluation-templates/EvaluationTemplateCreate.vue'),
        meta: {
            middleware: [GateKeeperMiddleware],
            ability: { action: 'create', subject: 'evaluation template' },
        },
    },
    {
        path: '/evaluation-templates/:evaluationTemplateId',
        name: 'evaluation-template-view',
        component: () => import('@/pages/evaluation-templates/EvaluationTemplateView.vue'),
        meta: {
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view', subject: 'evaluation template' },
        },
        props: true,
    },
    {
        path: '/evaluation-templates/:evaluationTemplateId/edit',
        name: 'evaluation-templates-edit',
        component: () => import('@/pages/evaluation-templates/EvaluationTemplateEdit.vue'),
        meta: {
            middleware: [GateKeeperMiddleware],
            ability: { action: 'edit', subject: 'evaluation template' },
        },
        props: true,
    },
];
